// extracted by mini-css-extract-plugin
export default {"mainComtainer":"PrivacyPolicy_mainComtainer__gacNX","header_main":"PrivacyPolicy_header_main__JQwOe","btnDiv":"PrivacyPolicy_btnDiv__QEYtS"};